

































































































































































import {
  Vue,
  Component,
} from "@/shared/vuepack";
import {
  EbtoResponse,
  EbtoTransferStep,
  EbtoCampaign,
  EbtoUserFinalizeRequest,
  CampaignDecision
} from "@/shared/types";
import { formatCurrency } from "@/shared/currency.js";
import * as _ from "lodash";
import moment from "moment";
import { EbtoRetained } from "@/employee/route-names";
import HsabLoginWrapper from "@/shared/components/ui/HsabLoginWrapper.vue";
import TransferStepsWidget from "@/employee/components/ebto/TransferStepsWidget.vue";
import OfferSummary from "@/employee/components/ebto/OfferSummary.vue";
import StayOfferSummary from "@/employee/components/ebto/StayOfferSummary.vue";
import ESignature from "./ESignature.vue";
import { useEbtoStore } from "@/shared/store/ebto";

@Component({
  components: {
    HsabLoginWrapper,
    TransferStepsWidget,
    ESignature,
    OfferSummary,
    StayOfferSummary
  }
})
export default class TransferProcess extends Vue {
  ebtoStore = useEbtoStore();

  moment = moment;

  formatCurrency = formatCurrency;
  EbtoTransferStep = EbtoTransferStep;
  currentStep = EbtoTransferStep.Provider;
  isSubmitting = false;
  transferOutDecision = CampaignDecision.TransferOut;

  get hasIncentiveBonus (): boolean {
    return this.ebtoStore.incentiveAmount > 0;
  }

  get showZeroAdminFeesCard (): boolean {
    return this.ebtoStore.isFeeWaived && this.ebtoStore.incentiveAmount === 0;
  }

  get hasPricingOffer (): boolean {
    return (this.hasIncentiveBonus || this.ebtoStore.isFeeWaived);
  }

  get isVerifyStep (): boolean {
    return (this.currentStep === EbtoTransferStep.Provider);
  }

  get isHaltDatesStep (): boolean {
    return (this.currentStep === EbtoTransferStep.HaltDates);
  }

  get isEnrollmentDatesStep (): boolean {
    return (this.currentStep === EbtoTransferStep.EnrollmentDates);
  }

  get isEnrollmentTermsStep (): boolean {
    return (this.currentStep === EbtoTransferStep.EnrollmentTerms);
  }

  get isESignStep (): boolean {
    return (this.currentStep === EbtoTransferStep.ESign);
  }

  get mappedStep (): EbtoTransferStep {
    if (this.isVerifyStep || this.isHaltDatesStep ||
      this.isEnrollmentDatesStep || this.isEnrollmentTermsStep) {
      return EbtoTransferStep.HaltDates;
    }

    return this.currentStep;
  }

  claimStayOffer (): void {
    if (this.isSubmitting) {
      return;
    }
    this.isSubmitting = true;
    this.ebtoStore.finalizeEbtoStayOffer({
      decision: CampaignDecision.Stay,
      userId: this.ebtoStore.verifiedUser.userId,
      eSignName: ""
    }).then(() => {
      this.isSubmitting = false;
      if (this.ebtoStore.isUserFlowComplete) {
        this.$router.push({ name: EbtoRetained });
      }
    });
  }

  confirmTransferOut (): void {
    this.currentStep = EbtoTransferStep.Confirm;

    if (this.isSubmitting) {
      return;
    }
    this.isSubmitting = true;
    this.ebtoStore.finalizeEbtoStayOffer({
      decision: CampaignDecision.TransferOut,
      userId: this.ebtoStore.verifiedUser.userId,
      eSignName: ""
    }).then(() => {
      this.isSubmitting = false;
    });
  }
}
